import {
  ADD_GROUP_FILTER_ID,
  CHANGE_ADDRESS_FILTER_GROUP,
  CHANGE_INDUSTRIAL_FILTER_GROUP,
  CHANGE_MULTIFAMILY_FILTER_GROUP,
  CHANGE_PROPERTY_FILTER_GROUP,
  CHANGE_PROPERTY_PAGE,
  CHANGE_SALE_FILTER_GROUP,
  CHANGE_SEARCH_TEXT,
  CHANGE_SORT,
  CLEAR_FILTERS,
  REMOVE_GROUP_FILTER_ID,
  SELECT_ASSET_CLASS,
  SELECT_AVAILABILITY,
  SELECT_BUILDING_CLASS,
  SELECT_EXCLUDE_TAGS,
  SELECT_INVESTMENT_TYPE,
  SET_ASSOCIATION_FILTERS,
  SET_ASSOCIATION_FILTER,
  SET_ASSET_CLASSES,
  SET_AVAILABILITIES,
  SET_BUILDING_CLASSES,
  SET_FULL_QUERY,
  SET_GROUP_FILTER_IDS,
  SET_INVESTMENT_TYPES,
  SET_TAGS
} from '../actions/query';

import { initialState } from '../../research_constants';

export default function (state = {}, action) {
  switch (action.type) {
  case CLEAR_FILTERS: {
    const { addressFilter, saleFilter, industrialFilter, multifamilyFilter, propertyFilter } = { ...initialState };
    return {
      ...state,
      addressFilter: { ...addressFilter },
      associationFilters: { ...initialState.associationFilters },
      saleFilter: { ...saleFilter },
      industrialFilter: { ...industrialFilter },
      multifamilyFilter: { ...multifamilyFilter },
      propertyFilter: { ...propertyFilter },
      availabilities: [],
      assetClasses: [],
      buildingClasses: [],
      investmentTypes: [],
      searchText: '',
      tags: [],
      tagIds: [],
      propertyPage: 1,
    };
  }
  case CHANGE_ADDRESS_FILTER_GROUP: {
    const addressFilter = { ...state.addressFilter, ...action.addressFilter };
    return {
      ...state,
      addressFilter: addressFilter,
      propertyPage: 1
    };
  }
  case CHANGE_MULTIFAMILY_FILTER_GROUP: {
    const multifamilyFilter = { ...state.multifamilyFilter, ...action.multifamilyFilter };
    return {
      ...state,
      multifamilyFilter: multifamilyFilter,
      propertyPage: 1
    };
  }
  case CHANGE_INDUSTRIAL_FILTER_GROUP: {
    const industrialFilter = { ...state.industrialFilter, ...action.industrialFilter };
    return {
      ...state,
      industrialFilter: industrialFilter,
      propertyPage: 1
    };
  }
  case CHANGE_PROPERTY_FILTER_GROUP: {
    const propertyFilter = { ...state.propertyFilter, ...action.propertyFilter };
    return {
      ...state,
      propertyFilter: propertyFilter,
      propertyPage: 1
    };
  }
  case CHANGE_PROPERTY_PAGE:
    return {
      ...state,
      propertyPage: action.page
    };
  case CHANGE_SORT:
    return {
      ...state,
      propertySort: action.sort
    };
  case CHANGE_SALE_FILTER_GROUP: {
    const saleFilter = { ...state.saleFilter, ...action.saleFilter };
    return {
      ...state,
      saleFilter: saleFilter,
      propertyPage: 1
    };
  }
  case CHANGE_SEARCH_TEXT:
    return {
      ...state,
      searchText: action.value,
      propertyPage: 1
    };
  case SET_FULL_QUERY:
    return {
      ...state,
      ...action.query,
      propertyPage: 1,
    };

  case SET_ASSOCIATION_FILTERS:
    return { ...state, associationFilters: action.associationFilters };

  case SET_ASSOCIATION_FILTER:
    return { ...state, associationFilters: { ...state.associationFilters, [action.key]: action.value } };

  case SELECT_AVAILABILITY: {
    let availabilities = state.availabilities;
    availabilities = _.reject(availabilities, availability => parseInt(availability) === parseInt(action.id));
    if (action.value) {
      availabilities.push(action.id);
    }
    return {
      ...state,
      availabilities: availabilities,
      propertyPage: 1
    };
  }
  case SELECT_ASSET_CLASS: {
    let assetClasses = state.assetClasses;
    assetClasses = _.reject(assetClasses, assetClass => parseInt(assetClass) === parseInt(action.role));
    if (action.value) {
      assetClasses.push(action.role);
    }
    return {
      ...state,
      assetClasses: assetClasses,
      propertyPage: 1
    };
  }
  case SELECT_BUILDING_CLASS: {
    let buildingClasses = state.buildingClasses;
    buildingClasses = _.reject(buildingClasses, buildingClass => buildingClass === action.role);
    if (action.value) {
      buildingClasses.push(action.role);
    }
    return {
      ...state,
      buildingClasses: buildingClasses,
      propertyPage: 1
    };
  }

  case SELECT_INVESTMENT_TYPE: {
    let investmentTypes = [...state.investmentTypes];
    investmentTypes = _.reject(investmentTypes, type => type === action.role);

    if (action.value) investmentTypes.push(action.role);
    return {
      ...state,
      investmentTypes,
      propertyPage: 1
    };
  }

  case SET_GROUP_FILTER_IDS:
    return {
      ...state,
      researchGroupIds: action.groupIds,
      propertyPage: 1
    };

  case ADD_GROUP_FILTER_ID: {
    if (state.researchGroupIds.includes(action.groupId)) {
      return state;
    }

    return {
      ...state,
      researchGroupIds: [...state.researchGroupIds, action.groupId].filter(groupId => groupId !== 'ungrouped'),
      propertyPage: 1
    };
  }

  case REMOVE_GROUP_FILTER_ID:
    return {
      ...state,
      researchGroupIds: state.researchGroupIds.filter(groupId => groupId !== action.groupId),
      propertyPage: 1
    };

  case SET_AVAILABILITIES:
    return {
      ...state,
      availabilities: action.availabilities,
    };
  case SET_ASSET_CLASSES:
    return {
      ...state,
      assetClasses: action.assetClasses,
    };
  case SET_BUILDING_CLASSES:
    return {
      ...state,
      buildingClasses: action.buildingClasses,
    };
  case SET_INVESTMENT_TYPES:
    return {
      ...state,
      investmentTypes: action.investmentTypes,
    };
  case SET_TAGS: {
    return {
      ...state,
      tags: [...action.tags],
      propertyPage: 1
    };
  }
  case SELECT_EXCLUDE_TAGS: {
    return {
      ...state,
      excludeTags: !state.excludeTags
    };
  }
  default:
    return state;
  }
}
